module["exports"] = ["#{street_name}#{building_number}", "#{street_name}#{building_number} #{secondary_address}"];